module.exports = __webpack_public_path__ + "img/StatusBar_Wifi.e7ab42ac.png";